module.exports = __webpack_public_path__ + "media/images/icons/v2/tag-01-eb076d30ab0ba2e3f1f35278245ce6c8.svg";